<template>
    <div>
        <div class="invoice_box" v-loading="loading">
            <div class="hidden_y">
                <el-button @click="back" slot="tt_r" type="primary" class="butn">返回</el-button>
                <span>订单号: {{orderid}}</span>
            </div>
            <div class="invoice_list">
                <div class="table_div">
                    发票信息
                    <span  v-if="fromData.type == 0">（ 增值税专用发票在申请开票后七个工作日内发出 )</span>
                    <span  v-if="fromData.type == 2">（ 普通纸质发票在申请开票后七个工作日内发出 )</span>
                    <el-button class="table_div_button"  type="text" v-if="fromData.type == 1 && fromData.status == 1" @click="add_xiang(fromData.downloadUrl)">下载电子发票</el-button>
                </div>
                <table class="table_box">
                    <colgroup>
                        <col width="20%">
                        <col width="60%">
                    </colgroup>

                    <tbody>
                    <tr>
                        <td>发票类型</td>
                        <td>{{ type[fromData.type] || '暂无数据'}}</td>
                    </tr>
                    <tr>
                        <td>发票状态</td>
                        <td>{{ status[fromData.status] || '暂无数据'}}</td>
                    </tr>
                    <tr>
                        <td>发票内容</td>
                        <td>服务费</td>
                    </tr>
                    <tr>
                        <td>发票抬头</td>
                        <td>{{ fromData.title || '暂无数据'}}</td>
                    </tr>
                    <tr>
                        <td>发票代码</td>
                        <td>{{ fromData.invoiceCode || '暂无数据' }}</td>
                    </tr>
                    <tr>
                        <td>发票号码</td>
                        <td>{{ fromData.invoiceNumber || '暂无数据' }}</td>
                    </tr>
                    <tr v-if="fromData.type == 0">
                        <td>发票邮寄订单号</td>
                        <td>{{ fromData.expressCode || '暂无数据' }}</td>
                    </tr>
                    </tbody>

                </table>
<!--                <div class="buttom_div">-->
<!--                    <el-button v-if="fromData.type == 1" class="_el_buttom"> 发送至邮箱</el-button>-->
<!--                </div>-->


            </div>

        </div>
    </div>
</template>

<script>
    export default {
        name: "xq_invoice",
        data() {
            return {
                loading:false,
                invoiceId: this.$route.params.invoiceId,
                fromData: {},
                orderid: this.$route.params.id,
                type: {
                    0: '增值税专用发票',
                    1: '电子发票',
                    2: '普通纸质发票',
                },
                status: {
                    '-1': '删除',
                    0: '开票中',
                    1: '开票完成'
                }
            }
        },
        mounted() {
            this.get_Invoice()
        },
        methods: {
            back() {
                this.$router.go(-1); //返回上一层
            },
            getBlob(url) {
                return new Promise(resolve => {
                    const xhr = new XMLHttpRequest();

                    xhr.open('GET', url, true);
                    xhr.responseType = 'blob';
                    xhr.onload = () => {
                        if (xhr.status === 200) {
                            resolve(xhr.response);
                        }
                    };

                    xhr.send();
                });
            },
            saveAs(blob, filename) {
                if (window.navigator.msSaveOrOpenBlob) {
                    navigator.msSaveBlob(blob, filename);
                } else {
                    const link = document.createElement('a');
                    const body = document.querySelector('body');

                    link.href = window.URL.createObjectURL(blob);
                    link.download = filename;

                    // fix Firefox
                    link.style.display = 'none';
                    body.appendChild(link);

                    link.click();
                    body.removeChild(link);

                    window.URL.revokeObjectURL(link.href);
                }
            },
            add_xiang(i){
                    let mySeal_file;
                    var a = document.createElement('a');
                    var url = i;
                    var filename = '电子发票.pdf';
                    a.href = url;
                    a.download = filename;
                    document.body.appendChild(a);
                    a.click();
                    window.URL.revokeObjectURL(url);
                    document.body.removeChild(a)
            },
            get_Invoice() {
                this.loading = true
                this.$SIF.httpPost({
                    url: this.$SIF._serve.order + "/functron/queryDetails/Invoice",
                    data: {
                        id: this.invoiceId,
                    },
                    succFun: res => {
                        this.fromData = res.data
                        this.loading = false
                    },
                    failFun: res => {
                        this.loading = false
                        this.$message({
                            message: res.msg,
                            type: 'warning'
                        });
                    }
                });
            }
        },
    }
</script>

<style scoped type="text/css">
    .invoice_box {
        width: 100%;
        background: #ffffff;
        height: 100%;
        position: relative;
    }
    .buttom_div{
        width: 70%;
        margin: 0 auto;
        padding-bottom: 50px;
    }
    .invoice_div {
        padding: 15px 0;
        width: 50%;
        margin: 0 auto;
    }

    .invoice_div .el-input {
        width: 80%;
    }

    .di_qu .el-select {
        width: 28%;
    }
    .table_div_button{
        float: right;
        text-decoration:underline;
    }
    ._el_buttom{
        color: #179B55;
        border: 1px solid #23B769;
        border-radius:8px;
    }

    .fa_piao .el-select {
        width: 80%;
    }

    .di_qu >>> .el-input {
        width: 85%;
    }

    .invoice_list {
        width: 100%;
        height: -webkit-calc(100% - 40px);
        height: -moz-calc(100% - 40px);
        height: calc(100% - 40px);
        overflow-x: hidden;
        overflow-y: auto;
    }

    .invoice_list::-webkit-scrollbar {
        width: 4px;
        /*height: 4px;*/
    }

    .invoice_bottom {
        width: 100%;
        text-align: center;
    }

    .invoice_list::-webkit-scrollbar-thumb {
        border-radius: 10px;
        -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        background: rgba(0, 0, 0, 0.2);
    }

    .invoice_list::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        border-radius: 0;
        background: rgba(0, 0, 0, 0.1);
    }

    .hidden_y {
        width: 100%;
        height: 40px;
        background: rgba(251, 251, 251, 1);
        border-radius: 5px 5px 0px 0px;
        line-height: 40px;
    }

    .hidden_y span {
        color: #0FC87D;
        font-size: 14px;
    }

    .table_div {
        width: 70%;
        margin: 0 auto;
        margin-top: 50px;
        height: 33px;
        line-height: 33px;
        background: rgba(237, 237, 237, 1);
        color: #434343;
        font-weight: 600;
        padding: 0 20px;
        overflow: hidden;
    }
    .table_div span{
        color:rgba(147,147,147,1);
    }

    .butn {
        margin-left: 20px;
        height: 26px;
        padding: 5px 10px;
        margin-right: 30px;
    }

    .table_box {
        width: 70% !important;
        margin: 0 auto;
        margin-bottom: 50px;
    }

    .table_box, .table_box tr th, .table_box tr td {
        border: 1px solid #DDDDDD;
    }

    .table_box {
        width: 200px;
        min-height: 25px;
        line-height: 25px;
        text-align: center;
        border-collapse: collapse;
        padding: 2px;
    }

    .table_box td {
        padding: 12px 20px;
    }
</style>